const Menu = [
  // { header: "Apps" },
  {
    title: "Dashboard",
    group: "apps",
    icon: "dashboard",
    name: "Dashboard",
    meta : ["login"]
  },
  // {
  //   title: 'Media',
  //   group: 'apps',
  //   name: 'Media',
  //   icon: 'perm_media',
  // },
  {
    title: "Manajemen Data Ruangan",
    group: "apps",
    component: "ruangan",
    icon: "fa fa-bars",
    meta : ["admin","RT","ruang"],
    items: [
      // { name: "ruangan", title: "Daftar Ruangan", component: "Daftar Ruangan", meta:["admin"] },
      // { name: "tambah_ruangan", title: "Tambah Ruangan", component: "Tambah Ruangan", meta:["admin"] }
    ]
  },

  {
    name: "ruangan",
    title: "Daftar Ruangan",
    component: "Daftar Ruangan",
    meta:["admin","RT","ruang"],
    parent: "Manajemen Data Ruangan"
  },
  {
    title: "Daftar Ruangan Tersedia",
    group: "apps",
    component: "Daftar Ruangan Tersedia",
    icon: "fa fa-search",
    name: "Daftar Ruangan Tersedia",
    meta: ["login"]
  },
  {
    name: "tambah_ruangan",
    title: "Tambah Ruangan",
    component: "Tambah Ruangan",
    meta:["admin","RT","ruang"],
    parent: "Manajemen Data Ruangan"
  },
  {
    title: "Peminjaman Ruangan",
    group: "apps",
    component: "peminjaman",
    icon: "fa fa-bars",
    meta:["admin", "RT","ruang","mhs", "dos", "akad"],
    items: [
      // { name: "daftar_peminjaman", title: "Daftar Peminjaman", component: "Daftar Peminjaman", meta:["admin"]},
      // { name: "tambah_ruangan", title: "Tambah Peminjaman", component: "Tambah Peminjaman", meta:["mhs, dos"] }
    ]
  },

  {
    name: "daftar_peminjaman",
    title: "Daftar Peminjaman",
    component: "Daftar Peminjaman",
    meta:["admin","RT","ruang","mhs","dos", "akad"],
    parent: "Peminjaman Ruangan"
  },
  {
    name: "tambah_ruangan",
    title: "Tambah Peminjaman",
    component: "Tambah Peminjaman2",
    meta:["admin","RT","ruang","mhs", "dos", "akad"],
    parent: "Peminjaman Ruangan"
  }

  // {
  //   title: "Laporan",
  //   group: "apps",
  //   component: "Laporan",
  //   icon: "fa fa-file",
  //   name: "Laporan",
  //   meta: ["login"]
  // },
  


  // { header: "CMS" },
  // {
  //   title: "List & Query",
  //   group: "layout",
  //   icon: "view_compact",
  //   items: [{ name: "Table", title: "Basic Table", component: "ListTable" }]
  // }
  // {
  //   title: 'Forms & Controls',
  //   group: 'forms',
  //   component: 'forms',
  //   icon: 'edit',
  //   items: [
  //     { name: 'basic', title: 'General', component: 'components/basic-forms' },
  //   ]
  // },
  // { divider: true },
  // { header: 'Extras' },
  // {
  //   title: 'Pages',
  //   group: 'extra',
  //   icon: 'list',
  //   items: [
  //     { name: 'Login', title: 'Login', component: 'Login' },
  //     { name: '404', title: '404', component: 'NotFound' },
  //     { name: '403', title: '403', component: 'AccessDenied' },
  //     { name: '500', title: '500', component: 'ServerError' },
  //   ]
  // },
]

export function navbar(role){
  console.log(role);

  var result = [];
  var flag = false;

  for (var i = 0; i < Menu.length; i++) {
    if (role) {
      if (Menu[i].meta.includes("login")) {
        result.push(Menu[i]);
      }
    }

    if (Menu[i].meta.includes(role) && !Menu[i].parent) {
      // console.log("masik");
      if (Menu[i].items) {
        Menu[i].items = []
        assignChildren(Menu[i], role);
      }
      result.push(Menu[i]);
    }
    flag = true;
  }
  if (flag) {
    console.log(result);
    return result;
  }
}

function assignChildren(parent, role) {
  console.log(role + " role");
  for (var i = 0; i < Menu.length; i++) {
    // console.log(items[i].parent === parent.name);
    if (Menu[i].parent === parent.title) {
      if (Menu[i].meta.includes(role)) {
        //console.log("ahoy");
        parent.items.push(Menu[i]);
      }
    }
  }
}

const navMe = navbar()

// reorder menu
// Menu.forEach(item => {
//   if (item.items) {
//     item.items.sort((x, y) => {
//       let textA = x.title.toUpperCase()
//       let textB = y.title.toUpperCase()
//       return textA < textB ? -1 : textA > textB ? 1 : 0
//     })
//   }
// })

export default {
  Menu,
  navMe
}
